import { md5 } from "./md5";
import { LogSentryException } from "./sentryLogger";

const UTM_CAMPAIGN_MAX_SIZE = 60;
const UTM_SOURCE_MAX_SIZE = 19;
const UTM_ADGROUP_MAX_SIZE = 19;

export const createMsStoreParam = (): string => {
  return "f-" + md5(Date.now().toString());
};

export const createCid = (): string => {
  const params = getUtmParams();
  let utmCampaignMaxSize = UTM_CAMPAIGN_MAX_SIZE;
  let { utm_campaign, utm_source, utm_adgroup } = params;
  try {
    utm_campaign = decodeURIComponent(utm_campaign);
    utm_source = decodeURIComponent(utm_source);
    utm_adgroup = decodeURIComponent(utm_adgroup);
  } catch (error) {
    LogSentryException({
      messagePrefix: "Error decoding utm params",
      error,
    });
  }

  // Handle leftovers characters from utm_source and utm_adgroup
  const utmSourceSize = encodeURIComponent(utm_source).length;
  const utmAdgroupSize = encodeURIComponent(utm_adgroup).length;
  utmCampaignMaxSize +=
    utmSourceSize < UTM_SOURCE_MAX_SIZE ? UTM_SOURCE_MAX_SIZE - utmSourceSize : 0;
  utmCampaignMaxSize +=
    utmAdgroupSize < UTM_ADGROUP_MAX_SIZE ? UTM_ADGROUP_MAX_SIZE - utmAdgroupSize : 0;

  while (encodeURIComponent(utm_campaign).length > utmCampaignMaxSize) {
    utm_campaign = utm_campaign.substring(0, utm_campaign.length - 1);
  }
  while (encodeURIComponent(utm_source).length > UTM_SOURCE_MAX_SIZE) {
    utm_source = utm_source.substring(0, utm_source.length - 1);
  }
  while (encodeURIComponent(utm_adgroup).length > UTM_ADGROUP_MAX_SIZE) {
    utm_adgroup = utm_adgroup.substring(0, utm_adgroup.length - 1);
  }

  utm_campaign = encodeURIComponent(utm_campaign);
  utm_source = encodeURIComponent(utm_source);
  utm_adgroup = encodeURIComponent(utm_adgroup);

  const cid = `${utm_campaign}.${utm_source}.${utm_adgroup}`;
  return cid !== ".." ? cid : "web_download_flow";
};

const getUtmParams = () => {
  const queryString = window.location.search;
  const queryParams = new URLSearchParams(queryString);

  return {
    utm_campaign: queryParams.has("utm_campaign") ? queryParams.get("utm_campaign") || "" : "",
    utm_source: queryParams.has("utm_source") ? queryParams.get("utm_source") || "" : "",
    utm_adgroup: queryParams.has("utm_adgroup") ? queryParams.get("utm_adgroup") || "" : "",
  };
};
